import { createRoute, redirect } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview as InvitationOverview } from 'domains/Organizations/Organization/AccessSettings/Invitations'
import { Overview as PeopleOverview } from 'domains/Organizations/Organization/AccessSettings/Members'
import { Overview as TeamsOverview } from 'domains/Organizations/Organization/AccessSettings/Teams'
import { Structure } from 'pages/NWPlatform/Organizations/Organization/Members/Structure'
import { organizationTabsOverviewLayoutRoute } from 'pages/NWPlatform/Organizations/Organization/Routing'

export const membersLayoutRoute = createRoute({
  getParentRoute: () => organizationTabsOverviewLayoutRoute,
  id: 'membersLayout',
  component: Structure,
})

export const membersRoute = createRoute({
  getParentRoute: () => membersLayoutRoute,
  path: StaticRouteParameter.MEMBERS,
  beforeLoad: ({ location }) => {
    if (
      location.pathname.endsWith(StaticRouteParameter.MEMBERS) ||
      location.pathname.endsWith(`${StaticRouteParameter.MEMBERS}/`)
    ) {
      throw redirect({
        replace: true,
        from: membersRoute.fullPath,
        to: usersOverviewRoute.to,
      })
    }
  },
})

type UsersOverviewSearch = {
  query?: string
}

export const usersOverviewRoute = createRoute({
  getParentRoute: () => membersRoute,
  path: StaticRouteParameter.USER,
  component: PeopleOverview,
  validateSearch: (search: Record<string, unknown>): UsersOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

type TeamsOverviewSearch = {
  query?: string
}

export const teamsOverviewRoute = createRoute({
  getParentRoute: () => membersRoute,
  path: StaticRouteParameter.TEAMS,
  component: TeamsOverview,
  validateSearch: (search: Record<string, unknown>): TeamsOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

export const invitationsOverviewRoute = createRoute({
  getParentRoute: () => membersRoute,
  path: StaticRouteParameter.INVITATIONS,
  component: InvitationOverview,
})
